<template>
  <div>
    <div :class="isCard == true ? 'card' : ''">
      <div class="card-header" v-if="title">
        <b-row>
          <b-col md="6">
            <h4 class="card-title" v-html="title" />
          </b-col>
        </b-row>
      </div>
      <div class="card-body">
        <p class="card-title-desc" v-if="subtitle" v-html="subtitle"></p>

        <b-row v-if="searchable">
          <b-col md="4">
            <label>{{ $t('Search') }}</label>
            <b-form-input v-model="search" type="text" id="search-table-input" :placeholder="$t('Search')" />
          </b-col>
          <b-col md="6" />
          <b-col md="2" v-if="showButtons">
            <label>&nbsp;</label>
            <div class="table-buttons">
              <button v-if="showCreateButton" @click="$emit('onCreate')" class="btn btn-primary">
                {{ $t('Create') }}
              </button>
              <button v-if="exportXls" @click="$emit('buttonXls')" class="ml-1 btn btn-success">XLS</button>
            </div>
          </b-col>
        </b-row>

        <br v-if="searchable" />

        <div v-if="!$store.state.isLoading" :class="`table-responsive ${showOptions ? 'table-with-options' : ''}`">
          <table :class="`table ${tableClass} mb-0`">
            <thead>
              <tr>
                <th v-if="selectable" class="-nowrap select-column-table">
                  <span v-if="selectAllButton" class="d-flex align-items-center">
                    <b-form-checkbox v-model="allItemsSelected" />
                    {{ $t('Select all') }}
                  </span>
                  <span v-else>{{ $t('Select') }}</span>
                </th>
                <th v-if="showOptions" v-text="$t('Options')" class="-nowrap options-column-table" />
                <th
                  :class="`-nowrap ${col.custom_class ? col.custom_class : ''} ${
                    col.short_name ? 'cursor-info' : ''
                  }`"
                  v-for="(col, c) in columns"
                  :key="c"
                  v-b-popover.hover.top="col.short_name ? col.label : ''"
                >
                  <span v-if="col.short_name">
                    {{ $t(col.short_name) }}
                  </span>
                  <span v-else>
                    {{ $t(col.label) }}
                  </span>
                </th>
                <th class="-nowrap text-center" v-if="customColumn">
                  {{ customColumnLabel }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, i) in items"
                :key="i"
                :class="rowClickable == true ? 'cursor-pointer' : ''"
                @click="$emit('rowClick', item)"
              >
                <td v-if="selectable" class="-nowrap text-center">
                  <b-row>
                    <b-col class="d-flex justify-content-center">
                      <b-form-checkbox
                        v-if="!canHideSelectAllButton"
                        :checked="selecteds.includes(item[keyToSelect])"
                        @click.stop="toggleSelect(item)"
                      />
                      <b-form-checkbox
                        v-else-if="
                          item['affiliate_payment_type'] === 'manual' && item['entry_id_entry_status'] === '2'
                        "
                        :checked="selecteds.includes(item[keyToSelect])"
                        @click.stop="toggleSelect(item)"
                      />
                    </b-col>
                  </b-row>
                </td>
                <td v-if="showOptions" class="-nowrap">
                  <button
                    id="btnGroupVerticalDrop1"
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ $t('Options') }} <i class="mdi mdi-chevron-down"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                    <a v-if="editable" class="dropdown-item cursor-pointer" @click="$emit('onEdit', item)">
                      {{ this.editLabel || $t('Edit') }}
                    </a>
                    <a
                      v-if="removable"
                      class="dropdown-item cursor-pointer"
                      @click="showExcludeConfirmation(item)"
                    >
                      {{ $t('Remove') }}
                    </a>
                    <a
                      v-if="customActionBtn"
                      class="dropdown-item cursor-pointer"
                      @click="$emit('customAction', item)"
                    >
                      {{ $t(customActionName) }}
                    </a>
                    <a
                      v-if="secondCustomActionBtn"
                      class="dropdown-item cursor-pointer"
                      @click="$emit('secondCustomAction', item)"
                    >
                      {{ $t(secondCustomActionName) }}
                    </a>
                  </div>
                </td>
                <td v-for="(col, c) in columns" :key="c">
                  <div
                    v-if="col.key != undefined && item[col.key] != undefined"
                    :class="`-nowrap ${col.custom_class ? col.custom_class : ''}`"
                  >
                    <span v-if="!col.formatter">
                      {{ `${item[col.key]}` }}
                    </span>
                    <span v-else>
                      {{ col.formatter(`${item[col.key]}`) }}
                    </span>
                  </div>
                </td>
                <td v-if="customColumn" class="text-center">
                  <div v-if="item.data">
                    <button class="btn btn-sm btn-secondary" @click="$emit('customColumnClick', item)">
                      <i class="mdi mdi-inbox-full"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="mt-3" v-if="showPagination">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              align="center"
            ></b-pagination>
          </div>
        </div>
        <Skeleton v-else />
        <b-modal v-model="modalExcludeVisible" :title="$t('Confirm exclude')" centered size="sm" @ok="onRemove">
          <h5>
            {{ $t('Do you want to delete this item?') }}
          </h5>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/bootstrap/skeleton';

export default {
  components: {
    Skeleton
  },
  props: {
    tableClass: {
      type: String,
      default: 'table-hover table-striped'
    },
    searchable: {
      default: false,
      type: Boolean
    },
    showPagination: {
      default: false,
      type: Boolean
    },
    tableSm: {
      default: false,
      type: Boolean
    },
    title: {
      default: '',
      type: String
    },
    rowClickable: {
      default: false,
      type: Boolean
    },
    subtitle: {
      default: '',
      type: String
    },
    editable: {
      default: false,
      type: Boolean
    },
    showButtons: {
      default: false,
      type: Boolean
    },
    showCreateButton: {
      default: true,
      type: Boolean
    },
    exportXls: {
      default: false,
      type: Boolean
    },
    removable: {
      default: false,
      type: Boolean
    },
    customColumn: {
      default: false,
      type: Boolean
    },
    customColumnLabel: {
      default: '',
      type: String
    },
    tableStriped: {
      default: true,
      type: Boolean
    },
    tableHover: {
      default: true,
      type: Boolean
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: 0
    },
    isCard: {
      type: Boolean,
      default: true
    },
    customActionBtn: {
      type: Boolean,
      default: false
    },
    secondCustomActionBtn: {
      type: Boolean,
      default: false
    },
    customActionName: {
      default: '',
      type: String
    },
    secondCustomActionName: {
      default: '',
      type: String
    },
    editLabel: {
      default: '',
      type: String
    },
    selectable: {
      default: false,
      type: Boolean
    },
    keyToSelect: {
      default: 'id',
      type: String
    },
    selectAllButton: {
      default: false,
      type: Boolean
    },
    selectedItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    canHideSelectAllButton: {
      default: true,
      type: Boolean
    }
  },
  mounted() {
    this.currentPage = 1;
    if (this.searchable) {
      this.enableSearch();
    }
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      modalExcludeVisible: false,
      item_to_delete: null,
      search: '',
      selecteds: this.selectedItems,
      allItemsSelected: false
    };
  },
  methods: {
    toggleSelect(item) {
      if (this.selecteds.includes(item[this.keyToSelect])) {
        this.selecteds = this.$utils.getObjectRaw(this.selecteds.filter((id) => id !== item[this.keyToSelect]));
      } else {
        this.selecteds.push(item[this.keyToSelect]);
      }
    },
    onSearch() {
      this.$emit('onSearch', this.search);
    },
    onRemove() {
      this.$emit('onRemove', this.item_to_delete);
      this.item_to_delete = null;
    },
    showExcludeConfirmation(item) {
      this.item_to_delete = null;
      this.item_to_delete = item;
      this.modalExcludeVisible = true;
    },
    enableSearch() {
      let input_search = document.getElementById('search-table-input');
      input_search.addEventListener(
        'keyup',
        this.$utils.debounce(() => {
          this.onSearch();
        })
      );
    }
  },
  watch: {
    currentPage(v) {
      this.$emit('onChangePage', v);
    },
    'selecteds.length'() {
      this.$emit('onSelect', this.selecteds);
    },
    allItemsSelected(v) {
      this.$emit('onSelectAll', v);
    },
    'selectedItems.length'() {
      this.selecteds = this.selectedItems;
    }
  },
  emits: [
    'onEdit',
    'onRemove',
    'onCreate',
    'onSearch',
    'onChangePage',
    'rowClick',
    'customAction',
    'customColumnClick',
    'secondCustomAction',
    'onSelect',
    'onSelectAll'
  ],
  computed: {
    showOptions() {
      return this.editable || this.removable || this.customActionBtn || this.secondCustomActionBtn;
    }
  }
};
</script>

<style lang="scss">
.table-with-options {
  th:nth-child(1) {
    width: 150px !important;
  }
}
.table-buttons {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  button {
    flex: 1;
  }
}
</style>
